<template>
  <div class="screen">
    <router-view v-if="isView"></router-view>
    <iframe v-else :src="iframeDrc" frameborder="0" style="width:100%;height:100%"></iframe>
    <div class="box" v-show="isMenu">
      <ul style="list-style:none">
        <li :class="li.class" v-for="(li,i) in data" :key="i" :tabindex="i">
          <a href="javascript:void(0)" @click="toMenu(li.name)">
           <h3>{{li.name}}</h3>
            <img :src="li.src" alt="img" />
          </a>
        </li>
        <div style="clear: both"></div>
      </ul>
    </div>
    <div class="botbtn" @click="hidemenu"></div>
  </div>

</template>

<script>
import img1 from "@/assets/picture/home/1.png";
import img1light from "@/assets/picture/home/1_light.png";
import img2 from "@/assets/picture/home/2.png";
import img2light from "@/assets/picture/home/2_light.png";
import img3 from "@/assets/picture/home/3.png";
import img3light from "@/assets/picture/home/3_light.png";
import img4 from "@/assets/picture/home/4.png";
import img4light from "@/assets/picture/home/4_light.png";
import img5 from "@/assets/picture/home/5.png";
import img5light from "@/assets/picture/home/5_light.png";

import zd from "@/assets/picture/home/zd.png";
import zdlight from "@/assets/picture/home/zd_light.png";

import ny from "@/assets/picture/home/ny.png";
import nylight from "@/assets/picture/home/ny_light.png";

import video from "@/assets/picture/home/video.png";
import videolight from "@/assets/picture/home/video_light.png";
import $ from "jquery";
export default {
  data() {
    return {
      data: [
        { class: "box_ul_li click", href: "#", src: img1light, name: "首页" ,path:"/home" },
        { class: "box_ul_li", href: "#", src: img2, name: "生产管理" ,path:"/product"},
        { class: "box_ul_li", href: "#", src: img3, name: "质量管理" ,path:"/quality"},
        { class: "box_ul_li", href: "#", src: img4, name: "设备管理" ,path:"/equipment"},
        { class: "box_ul_li", href: "#", src: zd, name: "设备诊断" ,path:"/phm"},
        { class: "box_ul_li", href: "#", src: img5, name: "安环管理" ,path:"/safety"},
        { class: "box_ul_li", href: "#", src: ny, name: "能源管理" },
        { class: "box_ul_li", href: "#", src: video, name: "智能视频" },
      ],
      isMenu: true,
      isView:true,
      iframeDrc:""
    };
  },
  components: {},
  created() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      let hrefstr= window.location.hash;
      let hrefres = hrefstr.substring(hrefstr.lastIndexOf("#/")+1)
      this.$router.push({ name: hrefres });
      let hrefItem= this.data.filter((item)=> item.path==hrefres)
      this.toMenu(hrefItem[0].name)
      $(".box ul li").hover(function () {
        $(this).addClass("on").siblings().removeClass("on");
      });
    },
    toMenu(name) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].name == name) {
          if (name == "首页") {
            this.isView=true;
            this.data[i].src = img1light;
            this.$router.push({ name: "home" });
            this.data[i].class = "box_ul_li click";
          } else if (name == "生产管理") {
            this.isView=true;
            this.data[i].src = img2light;
            this.$router.push({ name: "product" });
            this.data[i].class = "box_ul_li click";
          } else if (name == "质量管理") {
            this.isView=true;
            this.data[i].src = img3light;
            this.$router.push({ name: "quality" });
            this.data[i].class = "box_ul_li click";
          } else if (name == "设备管理") {
            this.isView=true;
            this.data[i].src = img4light;
            this.$router.push({ name: "equipment" });
            this.data[i].class = "box_ul_li click";
          } else if (name == "安环管理") {
            this.isView=true;
            this.data[i].src = img5light;
            this.$router.push({ name: "safety" });
            this.data[i].class = "box_ul_li click";
          } else if (name == "设备诊断") {
            this.isView=true;
            this.data[i].src = zdlight;
            this.$router.push({ name: "phm" });
            this.data[i].class = "box_ul_li click";
          }else if (name == "能源管理") {
            this.isView=false;
            this.data[i].src = nylight;
            this.data[i].class = "box_ul_li click";
            //window.location.href="http://117.187.82.89:8888/ems/cachepage5002/daping.do"
            this.iframeDrc="http://117.187.82.89:8888/ems/cachepage5002/daping.do"
          }else if (name == "智能视频") {
            this.isView=false;
            this.data[i].src = videolight;
            this.data[i].class = "box_ul_li click";
            this.iframeDrc="http://117.187.82.88:8000/#/kanban?companyId=694587217707794432"
            //window.location.href="http://117.187.82.88:8000/#/kanban?companyId=694587217707794432&sinoma=01"
          }
        }else{
          if (this.data[i].name == "首页") {
            this.data[i].src = img1;
          } else if (this.data[i].name == "生产管理") {
            this.data[i].src = img2;
          } else if (this.data[i].name == "质量管理") {
            this.data[i].src = img3;
          } else if (this.data[i].name == "设备管理") {
            this.data[i].src = img4;
          }else if (this.data[i].name == "设备诊断") {
            this.data[i].src = zd;
          }else if (this.data[i].name == "安环管理") {
            this.data[i].src = img5;
          }else if (this.data[i].name == "能源管理") {
            this.data[i].src = ny;
          }else if (this.data[i].name == "智能视频") {
            this.data[i].src = video;
          }
          this.data[i].class = "box_ul_li";
        }
      }

    },
    hidemenu() {
      this.isMenu = !this.isMenu;
    },
  },
};
</script>

<style scoped>
@import url("./menu.css");
@font-face {
  font-family: "pangmenzhangdao";
  src: url("../../assets/font/庞门正道标题体2.0增强版.woff2") format("woff2"),
    url("../../assets/font/庞门正道标题体2.0增强版.woff") format("woff"),
    url("../../assets/font/庞门正道标题体2.0增强版.ttf") format("truetype"),
    url("../../assets/font/庞门正道标题体2.0增强版.eot")
      format("embedded-opentype"),
    url("../../assets/font/庞门正道标题体2.0增强版.svg") format("svg");
}
.screen {
  height: 100%;
}


.botbtn {
  width: 2rem;
  height: 2rem;
  background: url("../../assets/picture/home/shouqi.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0.2rem;
  left: calc(50% - 1.1rem);
  cursor: pointer;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/views/bigScreen/index.vue